import React, { useRef }  from 'react';
import { useDispatch }    from "react-redux";
import useClickOutside    from "../../../hooks/useClickOutside";
import {
  triggerAboutTable,
  triggerHelpTable
}                         from "../../../store/layouts/actions";
import CloseIconComponent from "../../reusable/CloseIconComponent";
import './style.scss';

const {CONFIG} = window;


const HelpComponent = () => {
  const dispatch = useDispatch();
  const ref = useRef<HTMLDivElement>(null);

  const closeHandler = () => dispatch(triggerHelpTable(false));
  useClickOutside(ref, closeHandler);

  return (
    <div className='help'
         ref={ref}
    >
      <div className='help__title'>
        <CloseIconComponent handler={closeHandler}/>
        Help
      </div>
      <div className='help__content'>
        <div className='help-content__item'
             onClick={closeHandler}
        >
          <a href={`https://${CONFIG.ServerAddress}:${CONFIG.ServerPort}/help/OMS-55.htm`}
             rel="noopener noreferrer"
             target='_blank'
          >Web Client Help</a>
        </div>
        <div className='help-content__item'
             onClick={() => {
               dispatch(triggerAboutTable(true));
               closeHandler()
             }}
        >
          About
        </div>
      </div>
    </div>
  );
};


export default HelpComponent;